'use client';

import { Flex, Text } from '@chakra-ui/react';
import { FC } from 'react';
import { sortOptions } from '@/components/Product/SortBy/constants';
import { ISortOption } from '@/components/Product/SortBy/types';

type SortOptionsProps = {
  value: ISortOption;
  onChange?: (val: ISortOption) => void;
};

const SortOptions: FC<SortOptionsProps> = ({ value, onChange }) => {
  return (
    <Flex flexDir="column" gap="1rem">
      {sortOptions.map((opt) => {
        const isActive = opt.value === value.value;
        return (
          <Text
            key={opt.name}
            color="primary.300"
            cursor="pointer"
            userSelect="none"
            fontWeight={isActive ? '500' : '400'}
            onClick={() => onChange?.(opt)}
          >
            {opt.name}
          </Text>
        );
      })}
    </Flex>
  );
};

export default SortOptions;
